<template>

	<div class="auth">
		<div class="auth__container">


			<div class="row mb-3">
				<div class="col-12">
					<!-- go back -->
					<router-link :to="{name: 'Auth'}">
						<i class="fa fa-chevron-left"></i>
						{{ t('recover.link.back') }}
					</router-link>
				</div>
			</div>

			<!-- FORGOT PASSWORD -->

			<form @submit.prevent="validate('forgot')" data-vv-scope="forgot" v-show="state.forgot">
				<div class="row">
					<div class="col-12">
						<h1>
							{{ t('recover.title') }}
						</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<form-message :messages="getMessage( 'forgot')"></form-message>
					</div>
				</div>
				<div class="row">
					<!-- email -->
					<div class="col-12 form-group required">
						<label for="forgot__username">{{ t('auth.forgot') }}</label>
						<input
								v-model="form.forgot.id"
								v-validate="'required'"
								:class="validClasses('forgot.username')"
								name="username"
								type="text"
								class="form-control"
								id="forgot__username"
								:readonly="form.forgot.loading"
								:data-vv-as="t('field.username')"
								data-vv-scope="forgot"
						>
						<div v-if="isInValid('forgot.username')" class="invalid-feedback">
							{{ errors.first('forgot.username') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12" v-if="state.forgot">
						<!--<vue-recaptcha
								ref="captcha-scope-forgot"
								:sitekey="sitekey"
								size="invisible"
								@verify="startRecover"
								@expired="onCaptchaExpired('forgot')"
						>
						</vue-recaptcha>-->
					</div>
					<div class="col-12">
						<button class="btn btn-primary" :disabled="isLoad('recover_forgot')">{{ t('recover.submit.btn') }}
						</button>
					</div>
					<div class="col-12 mt-2">
						<a @click="setActive('code')" class="pointer">{{ t('recover.button.have.code') }}
						</a>
					</div>
				</div>
			</form>


			<!-- RECOVERY CODE -->

			<form @submit.prevent="validate('code')" data-vv-scope="code" v-show="state.code">
				<div class="row">
					<div class="col-12">
						<h1>
							{{ t('recover.code.title') }}
						</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<form-message :messages="getMessage( 'code')"></form-message>
					</div>
				</div>
				<div class="row">
					<div class="col-12" v-html="t('recover.code.description')"></div>
				</div>
				<div class="row mt-3">
					<!-- code -->
					<div class="col-12 form-group required">
						<label for="forgot__code">{{ t('recover.recoverCode') }}</label>
						<input
								v-model="form.code"
								v-validate="'required'"
								:class="validClasses('code.recoverToken')"
								name="recoverToken"
								type="text"
								:data-vv-as="t('field.recovercode')"
								class="form-control"
								id="forgot__code">
						<div v-if="isInValid('code.recoverToken')" class="invalid-feedback">
							{{ errors.first('code.recoverToken') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<button class="btn btn-primary" :disabled="isLoad('recover_code')">{{ t('recover.btn.submit') }}</button>
					</div>
				</div>
			</form>
			<form @submit.prevent="validate('secret')" data-vv-scope="secret" v-show="state.secret">
				<div class="row">
					<div class="col-12">
						<h2>
							{{ t('recover.title.secret') }}
						</h2>
						<div class="jumbotron pt-3 pb-3">
							<h3 class="mb-0">
								{{form.secret.question}}
							</h3>
						</div>

					</div>
				</div>
				<div class="row mt-3">
					<div class="col-12">
						<form-message :messages="getMessage( 'secret')"></form-message>
					</div>
				</div>
				<div class="row">
					<!-- answer -->
					<div class="col-12 form-group required">
						<label for="secret__answer">{{ t('auth.recover.secret_answer') }}</label>
						<input
								v-model="form.secret.answer"
								v-validate="'required'"
								:class="validClasses('secret.answer')"
								name="answer"
								type="text"
								class="form-control"
								id="secret__answer"
								:data-vv-as="t('field.answer')"
								:readonly="form.secret.loading"
								data-vv-scope="secret"
						>
						<div v-if="isInValid('secret.answer')" class="invalid-feedback">
							{{ errors.first('secret.answer') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12" v-if="state.secret">
						<!--<vue-recaptcha
								ref="captcha-scope-secret"
								:sitekey="sitekey"
								size="invisible"
								@verify="callAskQuestion"
								@expired="onCaptchaExpired('secret')"
						>
						</vue-recaptcha>-->
					</div>
					<div class="col-12">
						<button class="btn btn-primary" :disabled="isLoad('recover_secret')">{{ t('recover.submit.btn.secret') }}
						</button>
					</div>
				</div>
			</form>


			<!-- NEW PASSWORD -->

			<form @submit.prevent="validate('recover')" data-vv-scope="recover" v-show="state.recover">
				<div class="row">
					<div class="col-12">
						<h1>
							{{ t('recover.newpassword.title') }}
						</h1>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<form-message :messages="getMessage( 'recover')"></form-message>
					</div>
				</div>
				<div class="row">
					<!-- PASSWORD -->
					<div class="col-12 form-group required">
						<label for="recover__password">{{ t('recover.password') }}</label>
						<input
								v-model="form.recover.pass"
								v-validate="form.recover.validity"
								:class="validClasses('recover.password')"
								name="password"
								type="password"
								class="form-control"
								id="recover__password"
								:ref="'password'"
								:data-vv-as="t('field.password')"
								:readonly="form.recover.loading"
						>
						<div v-if="isInValid('recover.password')" class="invalid-feedback">
							{{ errors.first('recover.password') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12 form-group required">
						<label for="recover__password_confirm">{{ t('recover.passwordConfirm') }}</label>
						<input
								v-model="form.recover.confirm"
								v-validate="form.recover.validity2"
								:class="validClasses('recover.confirm')"
								name="confirm"
								type="password"
								class="form-control"
								id="recover__password_confirm"
								:data-vv-as="t('field.passwordconfirm')"
								:readonly="form.recover.loading"
						>
						<div v-if="isInValid('recover.confirm')" class="invalid-feedback">
							{{ errors.first('recover.confirm') }}
						</div>
					</div>
					<div class="col-12">
						<div class="form-text text-muted field__legend mb-3" v-html="t('register.passwordHint')">

						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-12" v-if="state.recover">
						<!--<vue-recaptcha
								ref="captcha-scope-recover"
								:sitekey="sitekey"
								size="invisible"
								@verify="postRecover"
								@expired="onCaptchaExpired('recover')"
						>
						</vue-recaptcha>-->
						<button class="btn btn-primary" type="submit" :disabled="isLoad('recover_recover')">{{
							t('recover.btn.submit') }}
						</button>
					</div>
				</div>
			</form>

			<div class="row" v-if="state.message">
				<div class="col-12">
					<h1 class="h1" :class="'title-state-'+form.message.state"
						 v-html="form.message.text">
					</h1>


				</div>
				<div class="col-12 mt-4">
					<router-link :to="{name: 'Auth'}" class="btn btn-primary">{{t('recover.btn.goto-login')}}</router-link>
				</div>
			</div>
		</div>
	</div>

</template>
<script>
	import Vuex from 'vuex';

	import {instance, authApi} from '@/api';
	//import VueRecaptcha from 'vue-recaptcha';
	import FormMessage from '@/components/parts/form-message';
	import {regex} from '@/config';


	/**
	 *
	 *   forgot => code => recover
	 *
	 *
	 * */

	export default {
		name: 'Recover',
		components: {
			//VueRecaptcha,
			FormMessage
		},
		props: [
			'recoveryCode'
		],
		data() {
			return {
				state: {
					forgot: false,
					code: false,
					recover: false,
					message: false,
					secret: false
				},
				form: {



					forgot: {
						active: false,
						id: '',
						loading: false
					},

					code: '',

					secret: {
						question: '',
						answer: '',
						loading: false
					},

					recover: {
						pass: '',
						confirm: '',

						validity: {
							required: true,
							min: 6,
							regex: regex.password
						},
						validity2: {
							required: true,
							min: 6,
							confirmed: 'password'
						},
						loading: false
					},

					message: {
						state: 'success',
						text: ''
					}
				}
			}
		},
		computed: {
			...Vuex.mapGetters({
				sitekey: 'getSitekey'
			})
		},
		watch: {
			recoveryCode(code) {
				if (code) {
					this.form.code = code;
					this.setActive('code');
					this.callAskQuestion();
				}
			},
			'state.invalid': function (inv) {
				if (!inv) {
					this.form.message.text = '';
				}
			}
		},
		mounted() {

			if (this.recoveryCode) {
				this.form.code = this.recoveryCode;
				this.setActive('code');
				this.callAskQuestion();
			}else{
				this.setActive('forgot');
			}
			this.deleteMessage('forgot');
			this.deleteMessage('secret');
			this.deleteMessage('recover');
			//window.recov = this;
		},
		methods: {
			setActive(active) {
				//Set active view
				for (let s in this.state) {
					if (s !== active) {
						this.state[s] = false;
					}
				}
				this.state[active] = true;

			},

			/*onCaptchaExpired(scope) {
				//Refresh captcha
				this.form[scope].loading = false;
				if(this.$refs['captcha-scope-' + scope]){
					this.$refs['captcha-scope-' + scope].reset();
				}


			},*/
			validate(scope) {
				//Validate by each scope
				this.addLoad('recover_'+scope);
				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						// eslint-disable-next-line
						console.info('Form Submitted: ' + scope);

						//If form valid, then do send process
						switch (scope) {
							case 'forgot':
								this.startRecover(); // Send user email id, and if valid send recovery code by email to him
								break;
							case 'code':

								this.callAskQuestion(); //Get secret question by recovery code.
								break;
							case 'secret':
								this.callAnswerQuestion();
								break;
							case 'recover':

								//Fields valid, block changes
								//this.form[scope].loading = true;

								this.postRecover(); //Send to REST, code, answer, password and confirmation
								break;

						}

					}else{
						this.endLoad('recover_'+scope);
					}
				});
			},



			startRecover() {
				const scope = 'forgot';
				//Ask backend if user exist and could we recover password

				this.deleteMessage(scope);
				instance.post(authApi.recover.step1,{
					email: this.form.forgot.id
				})
					.then((responce) => {

						if (this.isError(responce)) {
							/*let msg = responce.data.error.code.replace(/_\((.*?)\)$/, '$1');
							this.handleSipleValidation({
								'username': this.t('message.'+msg)
							});*/

							this.restMessageHandler(responce.data.status, scope, responce.data.error);
						} else if (this.isSuccess(responce)) {

							this.setActive('code');
						}

					})
					.catch((er) => {
						console.warn(er);

						this.addMessage( {
							scope: scope,
							state: 'warning',
							text: this.t('api.problem.network')
						});
					}).then(() => {
						//alvays
						//Clear loading and reset captcha
						
						this.endLoad('recover_'+scope);
					});
			},
			callAskQuestion(){
				const scope = 'code';

				this.deleteMessage(scope);


				instance.post(authApi.recover.step2, {
					recoveryCode: this.form.code
				}).then((responce) => {

					if (this.isError(responce)) {
						//Error handling

						this.restMessageHandler(responce.data.status, scope, responce.data.error);

					} else if (this.isSuccess(responce)) {
						//SUCCESS handling
						if(responce.data.content.force_change){
							this.setActive('recover');
						}else{
							this.form.secret.question = responce.data.content.secret_question;
							this.setActive('secret');
						}

					}

				}).catch((er) => {
					console.log(er);
					this.addMessage( {
						scope: scope,
						state: 'warning',
						text: this.t('api.problem.network')
					});
				}).then(() => {
					//alvays
					
					this.endLoad('recover_'+scope);
				});
			},
			callAnswerQuestion(){
				const scope = 'secret';

				this.deleteMessage(scope);


				instance.post(authApi.recover.step25, {
					recoveryCode: this.form.code,
					secret_response: this.form.secret.answer
				}).then((responce) => {

					if (this.isError(responce)) {
						//Error handling

						this.restMessageHandler(responce.data.status, scope, responce.data.error);

					} else if (this.isSuccess(responce)) {
						//SUCCESS handling
						this.setActive('recover');

					}

				}).catch((er) => {
					console.log(er);
					this.addMessage( {
						scope: scope,
						state: 'warning',
						text: this.t('api.problem.network')
					});
				}).then(() => {
					//alvays

					this.endLoad('recover_'+scope);
				});
			},
			postRecover() {
				const scope = 'recover';

				this.deleteMessage(scope);
				//Last step, we send all info to server
				let data = {
					recoveryCode: this.form.code,
					secret_response: this.form.secret.answer,
					new_password: this.form.recover.pass,
					new_password_confirmation: this.form.recover.confirm
				};

				instance.post(authApi.recover.step3, data)
					.then((responce) => {
						if (this.isError(responce)) {
							//If backend return error,

							this.restMessageHandler(responce.data.status, scope, responce.data.error, 'step3');

						} else if (this.isSuccess(responce)) {
							//Recover success, should return user and loged in
							this.form.message.state = 'success';
							this.form.message.text = this.t(responce.data.content.message.replace(/_\((.*?)\)$/, '$1'));
							this.setActive('message');


						} else {
							this.addMessage( {
								scope: scope,
								state: 'warning',
								text: this.t('api.problem.network')
							});
						}

					})
					.catch(() => {
						this.addMessage( {
							scope: scope,
							state: 'warning',
							text: this.t('api.problem.network')
						});
					}).then(() => {
						//alvays
						console.log('always.'+scope);
						
						this.endLoad('recover_'+scope);
				});
			},

			isSuccess(responce) {
				return responce.data.status && responce.data.status === 'SUCCESS' ;
			},
			isError(responce) {
				return (responce.data.status && responce.data.status === 'ERROR') || responce.data.error || (responce.data.content && typeof responce.data.content.error !== 'undefined')
			},
			networkError(er) {
				console.warn('Auth network error: ' + er);
				this.form.message.state = 'warning';
				this.form.message.text = this.t('api.problem.network');
				this.setActive('message');
			},





		}
	}
</script>
<style lang="scss">
	@import "../../scss/components/auth";
</style>